import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useSession } from '@/auth/useSession';
import { UserMenu } from '@/auth/UserMenu';
import logo from '@/assets/branding/idea-tsg-logo.svg';

export default function App() {
  const { t } = useTranslation();
  const { data: me } = useSession();

  return (
    <div className="flex min-h-screen flex-col bg-white text-slate-900">
      <header className="flex items-center justify-between border-b bg-white px-6 py-4 shadow-sm">
        <Link to="/" className="flex items-center" aria-label={t('app.title')}>
          <img src={logo} alt="IDEA TSG · AppSoluciones" className="h-7 w-auto sm:h-8" />
        </Link>
        <div className="flex items-center gap-4">
          {me?.is_admin && (
            <Link
              to="/admin"
              className="text-sm font-medium text-appsol-900 hover:underline"
            >
              {t('app.adminLink')}
            </Link>
          )}
          {me && <UserMenu name={me.display_name} />}
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl flex-1 px-6 py-8">
        <Outlet />
      </main>
      <footer className="border-t bg-white px-6 py-3 text-center text-xs text-slate-500">
        {t('app.footer')}
      </footer>
    </div>
  );
}
